import { z } from "zod";

/**
 * Generic document metadata - stored in Document.metadata Json field.
 */
export const DocumentMetadataSchema = z.record(z.string(), z.unknown());
